const TRACKER_LINK_RE = /tracker\.yandex\.ru\/([A-Z][A-Z0-9_]+-\d+)/i;

/**
 * Extract the first Yandex Tracker task key from event description.
 * Looks for links like tracker.yandex.ru/QUEUE-123.
 */
export const extractTaskKey = (description: string | null): string | null => {
  if (!description) {
    return null;
  }

  const match = description.match(TRACKER_LINK_RE);
  return match ? match[1].toUpperCase() : null;
};
